<template>
  <div class="main-frame">
    <div class="info-frame">
      <!-- <van-nav-bar title="SMOK" class="top_bar" fixed @click-left="backHome()">
        <template #title>
          <img class="logo-img" src="../assets/image/smoklogo.png" />
        </template>
        <template #left>
          <van-icon name="arrow-left" size="20" color="#000" />
        </template>
        <template #right>
          <van-icon
            name="qr"
            size="20"
            color="#000"
            v-clipboard:copy="ACodeStr"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
          />
        </template>
      </van-nav-bar> -->

      <backHeader :ACodeStr="ACodeStr"> </backHeader>

      <!-- 占位高度 -->
      <van-divider class="top-divider" :style="{ borderColor: '#FFF' }" />
      <!-- 状态图片 -->
      <img v-if="status == 1" class="title-img" src="../assets/image/img-activate.png" />
      <img v-if="status == 2" class="title-img" src="../assets/image/img_fake.png" />
      <!-- 产品名称 -->
      <P class="product-name">{{ text.name }}</P>
      <!-- 批次编号 -->
      <P class="sn-num">{{ $t("message.A_nonactivate_SNhint") }} {{ text.batch_no }}</P>
      <!-- 状态提示信息 -->
      <P class="title-cur">{{ $t("message.A_nonactivate_cur") }}</P>
      <!-- 状态 -->
      <P class="title-act">{{ $t("message.A_activate_act") }}</P>
      <!-- 绑定信息 -->
      <P v-show="showEmail" class="title-end">{{
        $t("message.A_activate_bind_email", { email: text.email })
      }}</P>
      <P v-show="showDevice" class="title-end">{{
        $t("message.A_activate_bind_device", { device: text.device_uuid })
      }}</P>
      <!-- 警告信息 -->
      <P class="title-warning"
        >{{ $t("message.A_nonactivate_time", { count: text.count })
        }}{{ $t("message.A_activate_purchase") }}</P
      >
      <!-- 举报按钮 -->
      <van-button
        class="activate-btn"
        type="info"
        color="#30b3f0"
        @click="handleClick()"
        >{{ $t("message.A_activate_report") }}</van-button
      >
      <!-- APP下载 -->
      <van-button
        icon="wap-home-o"
        type="info"
        color="#30b3f0"
        class="download-btn"
        @click="downloadApp"
        >{{ $t("message.home_button_app") }}</van-button
      >
      <!-- 防伪码教程 -->
      <div class="fake_title">
        <a href="https://www.smoktech.com/web-anti-counterfeiting-system">{{
          $t("message.home_fake_title")
        }}</a>
      </div>
      <div style="margin-top: 20px" v-if="status == 1">
        <IncreaseFlow />
      </div>
    </div>
    <div class="bottom-view">
      <!-- 装饰线条 -->
      <img class="img-margin" src="../assets/image/footer.png" />
      <!-- 版权说明 -->
      <foot></foot>
    </div>
  </div>
</template>

<script>
import foot from "@/components/Foot.vue";
import backHeader from "@/components/BackHeader.vue";
import IncreaseFlow from "@/components/IncreaseFlow.vue";

export default {
  components: {
    foot,
    backHeader,
    IncreaseFlow
  },
  name: "A_activate",
  data() {
    return {
      text: {
        name: "",
        email: "",
        device_uuid: "",
      },
      ACodeStr: "",
      status: 0,
      showEmail: false,
      showDevice: false,
    };
  },
  created() {
    if (this.$route.params.data != undefined) {
      this.text = this.$route.params.data;
      this.ACodeStr = A_PREV + this.$route.params.data.info_code;
      this.status = this.$route.params.status;
      if (this.text.email.length > 0) {
        this.showEmail = true;
      } else if (this.text.device_uuid.length > 0) {
        this.showDevice = true;
      }
    } else {
      // 返回主页
      this.$notify(this.$t("message.home_model_not_scanner_code_a"));
      this.$router.push({ name: "bind-home" });
    }
  },
  methods: {
    backHome() {
      this.$router.push({ name: "bind-home" });
    },
    downloadApp() {
      this.$router.push({ name: "home" });
    },
    handleClick() {
      this.$router.push({ name: "inform", params: { data: this.text } });
    },
    onCopy(e) {
      console.log(e.text);
      this.$notify({ type: "success", message: this.$t("message.copy_a_success") });
    },
    onError(e) {
      console.log(e);
      this.$notify(this.$t("message.copy_a_fail"));
    },
  },
};
</script>

<style scoped>
.main-frame {
  /*width: 100%;*/
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  background-color: white;
  text-align: center;
}

.info-frame {
  flex: 1;
}

.top-divider {
  background-color: white;
  margin: 0;
  height: 55px;
}

.title-img {
  width: 90px;
  height: 90px;
  margin-top: 20px;
}

.product-name {
  margin-left: 16px;
  margin-top: 30px;
  font-size: 14pt;
  font-weight: bold;
  width: calc(100% - 32px);
}

.sn-num {
  margin-left: 16px;
  margin-top: 4px;
  font-size: 12pt;
  font-weight: 300;
  width: calc(100% - 32px);
}

.title-cur {
  margin-left: 16px;
  margin-top: 16px;
  font-size: 12pt;
  font-weight: bold;
  width: calc(100% - 32px);
  color: #999;
}

.title-act {
  margin-left: 16px;
  margin-top: 8px;
  font-size: 14pt;
  width: calc(100% - 32px);
  font-weight: 300;
  color: #f64b49;
}

.title-end {
  margin-left: 16px;
  margin-top: 8px;
  font-size: 12pt;
  width: calc(100% - 32px);
  color: #999;
}

.title-warning {
  margin-left: 16px;
  margin-top: 30px;
  font-size: 10pt;
  width: calc(100% - 32px);
  color: #f64b49;
}

.activate-btn {
  margin-top: 40px;
  font-size: 14pt;
  width: calc(100% - 32px);
  border-radius: 8px;
}

.download-btn {
  margin-top: 16px;
  font-size: 14pt;
  width: calc(100% - 32px);
  border-radius: 8px;
}

.fake_title {
  margin-top: 20px;
  margin-left: 16px;
  width: calc(100% - 32px);
  font-size: 12pt;
}

.fake_title a {
  color: #03aef9;
}

.text-codeb {
  margin-left: 16px;
  margin-top: 8px;
  font-size: 12pt;
  width: calc(100% - 32px);
  color: #999;
}

.img-margin {
  width: 100%;
  height: 22px;
}

.bottom-view {
  min-height: 50px;
  margin-top: 20px;
  background-color: white;
}
</style>
